export function createBankResult(bank, params, type) {
    const baseResult = {
        type: type,
        id: bank.id,
        idFM: bank.id_for_marketplace,
        name: bank.name,
        logo: params.logo,
        website: bank.website,
        minRate: formatValue(bank.effectiveRateMin),
        maxRate: formatValue(bank.effectiveRateMax),
        baseRate: formatValue(bank.baseRate),
        isMaxRate: params.isMaxRate,
        activePromosCount: params.activePromosCount,
        promosCount: params.promosCount,
        license: params.license,
    };
    switch (type) {
        case "byCard": {
            const config = params;
            return {
                ...baseResult,
                type: "byCard",
                rate: formatValue(config.rate),
                payment: formatValue(config.payment),
            };
        }
        case "byIncome": {
            const config = params;
            return {
                ...baseResult,
                type: "byIncome",
                rate: formatValue(config.rate),
                credit: formatValue(config.credit),
                amount: formatValue(config.amount),
                overpayment: formatValue(config.overpayment),
                payment: formatValue(config.payment),
            };
        }
        case "bySum": {
            const config = params;
            return {
                ...baseResult,
                type: "bySum",
                rate: formatValue(config.rate),
                income: formatValue(config.income),
                overpayment: formatValue(config.overpayment),
                payment: formatValue(config.payment),
            };
        }
        case "byIslamic": {
            const config = params;
            return {
                ...baseResult,
                type: "byIslamic",
                income: formatValue(config.income),
                payment: formatValue(config.payment),
            };
        }
        default: {
            const _exhaustiveCheck = type;
            throw new Error(`Unhandled calculation type: ${_exhaustiveCheck}`);
        }
    }
}
export function formatValue(value, precision = 2) {
    const multiplier = Math.pow(10, precision);
    return Math.round(value * multiplier) / multiplier;
}
